var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMed004(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M11 3C11 3.6 10.6 4 10 4V9H4H5C5.6 9 6 8.6 6 8C6 7.4 5.6 7 5 7H4V4C3.4 4 3 3.6 3 3C3 2.4 3.4 2 4 2H10C10.6 2 11 2.4 11 3ZM20 2H14C13.4 2 13 2.4 13 3C13 3.6 13.4 4 14 4V7H15C15.6 7 16 7.4 16 8C16 8.6 15.6 9 15 9H14V12H15C15.6 12 16 12.4 16 13C16 13.6 15.6 14 15 14H14H20V4C20.6 4 21 3.6 21 3C21 2.4 20.6 2 20 2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9V19C10 20.7 8.7 22 7 22C5.3 22 4 20.7 4 19H5C5.6 19 6 18.6 6 18C6 17.4 5.6 17 5 17H4V14H5C5.6 14 6 13.6 6 13C6 12.4 5.6 12 5 12H4V9H10ZM14 14V17H15C15.6 17 16 17.4 16 18C16 18.6 15.6 19 15 19H14C14 20.7 15.3 22 17 22C18.7 22 20 20.7 20 19V14H14Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMed004);
export default __webpack_public_path__ + "static/media/med004.b86b7576c783de56ee6b786060365cc7.svg";
export { ForwardRef as ReactComponent };